import React from 'react'
import Header from '../Components/Header'

const BlogScreen = () => {
  return (
    <>
      <Header />
      <h1>BlogScreen</h1>
    </>
  )
}

export default BlogScreen
